import http from './http'

export default {
  get(url, params, config) {
    return http.get(url, { params, ...config })
  },

  post(url, data, config) {
    return http.post(url, data, config)
  },

  put(url, data, config) {
    return http.put(url, data, config)
  },

  delete(url, config) {
    return http.delete(url, config)
  }
}
